import { useDealContext } from "@/contexts/DealContext";
import { Box, Toolbar, Typography } from "@mui/material";

const Header = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { deal } = useDealContext();
  return (
    <Toolbar>
      <Box display="flex" flexDirection="column">
        <Typography variant="h6">LoanAI</Typography>
        <Typography variant="body2">Loan Digitization by AI</Typography>
      </Box>
    </Toolbar>
  );
};

export default Header;
